import React from "react"

function GlobalContext({ children }) {
  return <>{children}</>
}

export default GlobalContext
